import fetch from '../../../utils/fetch'

const getInitialState = () => {
  return {
    isLoading: false,
    topics: [],
    error: null,
  }
}

const state = getInitialState();

const getters = {
  allTopics(state) {
    if (state.topics && state.topics.all) {
      return state.topics.all;
    } else {
      return [];
    }
  },
  /* later?
  popularTopics(state) {
    if (state.topics) {
      return state.topics.popular;
    } else {
      return []
    }
  },
  */

  isLoading(state) {
    return state.isLoading
  },
  error(state) {
    return state.error
  },
}

const actions = {

  get({commit, rootState}) {
    commit(types.RESET)
    commit(types.SET_ALL_PROJECT_TOPICS_LOADING);
    return fetch('/topics')
      .then(response => {
        return response.json();
      })
      .then((data) => {
        commit(types.SET_ALL_PROJECT_TOPICS, data);
        return data;
      })
      .catch((error) => {
        commit(types.SET_ALL_PROJECT_TOPICS_ERROR, error);
        return Promise.reject(error);  // Return rejected promise instead of throw
      });
  },
}

const types = {
  SET_ALL_PROJECT_TOPICS_LOADING: 'SET_ALL_PROJECT_TOPICS_LOADING',
  SET_ALL_PROJECT_TOPICS: 'SET_ALL_PROJECT_TOPICS',
  SET_ALL_PROJECT_TOPICS_ERROR: 'SET_ALL_PROJECT_TOPICS_ERROR',
  RESET_ERROR: 'RESET_ERROR',
  RESET: 'RESET',
}

const mutations = {
  [types.SET_ALL_PROJECT_TOPICS_LOADING](state) {
    state.isLoading = true;
  },
  [types.SET_ALL_PROJECT_TOPICS](state, topics) {
    state.topics = topics;
    state.isLoading = false;
  },
  [types.SET_ALL_PROJECT_TOPICS_ERROR](state, error) {
    state.error = error;
    state.isLoading = false;
  },

  [types.RESET_ERROR](state) {
    state.error = null;
  },
  [types.RESET](state) {
    Object.assign(state, getInitialState());
  },
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}
